var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.05978 0 0 .05978 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    fill: "#666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 232c0 48.52 39.48 88 88 88s88-39.48 88-88-39.48-88-88-88-88 39.48-88 88zm160 0c0 39.696-32.296 72-72 72s-72-32.304-72-72 32.296-72 72-72 72 32.304 72 72z",
    transform: "translate(-184 -184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.856 82.56c0-.048-.016-.024-.016-.024h-.008c-.056-.064-.12-.128-.176-.184l-80-80A7.973 7.973 0 00248 0H56C42.768 0 32 10.768 32 24v320c0 13.232 10.768 24 23.992 24H312c13.232 0 24-10.768 24-24V88a7.981 7.981 0 00-2.144-5.44zM320 344c0 4.408-3.584 8-8 8H55.992c-4.408 0-7.992-3.584-7.992-8V24c0-4.408 3.584-8 8-8h168v32H88c-4.424 0-8 3.584-8 8v48c0 4.416 3.576 8 8 8 4.424 0 8-3.584 8-8V64h128v40c0 4.416 3.576 8 8 8h88v232zm0-248h-80V16h4.688L320 91.32V96z",
    transform: "translate(-184 -184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.656 202.344a7.991 7.991 0 00-11.312 0 7.991 7.991 0 000 11.312L172.688 232l-18.344 18.344a7.991 7.991 0 000 11.312A7.978 7.978 0 00160 264a7.978 7.978 0 005.656-2.344L184 243.312l18.344 18.344A7.978 7.978 0 00208 264a7.978 7.978 0 005.656-2.344 7.991 7.991 0 000-11.312L195.312 232l18.344-18.344a7.991 7.991 0 000-11.312 7.991 7.991 0 00-11.312 0L184 220.688l-18.344-18.344z",
    transform: "translate(-184 -184)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRequest);
export default __webpack_public_path__ + "static/media/cancel-request.6859bc5c25db4e48a63318707b3935c6.svg";
export { ForwardRef as ReactComponent };